import './kp-record-editation.less';
import type {Component} from 'typings/portaro.fe.types';
import kpRecordEditationTemplate from './kp-record-editation.tpl.ftl';
import {ofCode} from '../record-filter-utils';
import type {IAugmentedJQuery, IFormController, ITimeoutService, IWindowService} from 'angular';
import type {Field} from 'typings/portaro.be.types';
import type RecordEditationService from '../record-editation.service';
import type {FileService} from '../../file/file.service';
import FieldEditForm from './FieldEditForm.svelte';
import IndicatorsEditForm from './IndicatorsEditForm.svelte';
import EmptyFieldAddMenu from './EmptyFieldAddMenu.svelte';


export abstract class KpRecordEditationComponentController implements KpRecordEditationComponentBindings {
    public editation: RecordEditationService;
    public showIndicators: boolean;
    public showFieldIdentifiers: boolean;
    public ofCode: (code: string) => (f) => boolean;
    public editationForm: IFormController;
    public element: HTMLElement;
    public scrollingElement: Element;
    public fieldEditFormComponent = FieldEditForm;
    public indicatorsEditFormComponent = IndicatorsEditForm
    public emptyFieldAddMenuComponent = EmptyFieldAddMenu;

    public abstract onChange();

    /*@ngInject*/
    constructor(private fileService: FileService, private SERVER_URL: string, $element: IAugmentedJQuery, private $timeout: ITimeoutService, $window: IWindowService) {
        this.ofCode = ofCode;
        this.element = $element[0];
        this.scrollingElement = $window.document.scrollingElement;
    }

    public submitFieldValue(field: Field) {
        if (!!this.onChange) {
            this.onChange();
        }
        this.editation.setFieldValue(field);
    }

    public onFileDrop(subfield, fileDatas) {
        if (fileDatas.length > 1) {
            throw new Error('Cannot set more than 1 file to 1 subfield');
        }
        this.fileService.uploadFile(this.editation.directoryId(), fileDatas[0])
            .then((file) => {
                subfield.value = `${this.SERVER_URL}/media-viewer?rootDirectory=${file.directory.id}#!?file=${file.id}`;
                this.editation.setFieldValue(subfield);
            });
    }

    public replaceSpecialCharsForIdAttribute(str) {
        return str
            .replace(/#/gi, '-')
            .replace(/\./gi, '-');
    }

    public addEmptyField(fieldToAdd) {
        this.editation.addEmptyField(fieldToAdd)
            .subscribe(() => {
                this.$timeout(() => this.scrollToField(fieldToAdd));
            });
    }

    public scrollToField(field) {
        const code = field.code;

        const fields = this.element.querySelectorAll<HTMLDivElement>(`[id^="${code}#"]`);
        const lastOccurrence = fields[fields.length - 1];

        this.scrollingElement.scrollTop = lastOccurrence.offsetTop - 120 - 50 - 230; // 120 = height of sticky header; 50 = height of menu; 230 = some empiric value sucked from little finger
    }
}

/**
 * @ngdoc component
 * @name kpRecordEditation
 * @module portaro.editation
 *
 * @param {any} editation Editation object
 * @param {boolean=} showIndicators May it show indicator?
 * @param {boolean=} showFieldIdentifiers May it show field numbers?
 * @param {function} onChange On change callback with injectable variable `$valid` which is self describing.
 *
 * @description
 *
 */
export default class KpRecordEditationComponent implements Component<KpRecordEditationComponentBindings> {
    public static componentName = 'kpRecordEditation';

    public templateUrl = kpRecordEditationTemplate;

    public bindings = {
        editation: '=',
        showIndicators: '<?',
        showFieldIdentifiers: '<?',
        onChange: '&?'
    } as const;

    public controller = KpRecordEditationComponentController;
}

interface KpRecordEditationComponentBindings {
    editation: RecordEditationService;
    showIndicators?: boolean;
    showFieldIdentifiers?: boolean;

    onChange();
}
